<template>
    <form c @submit.prevent="validateBeforeSubmit"
          class="form-with-loading form full-width-form bg-light p-2 p-lg-5" method="POST" id="contact-form">
        <!--        @csrf-->

        <h3 class="form-col__title">
            Kontaktirajte nas
        </h3>
        <template  v-if="isSend">
            <div class="alert alert-success alert-dismissible fade show" role="alert">
                <strong>Poruka poslata!</strong> Uskoro ćemo vas kontaktirati.
                <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
        </template >
        <template  v-if="isLoading">
        <div class="form-loading" >
<!--            <i class="form-loading__icon fa fa-spinner fa-spin fa-3x fa-fw"></i>-->
            <div class="loader loader--style3" title="2">
                <svg version="1.1" id="loader-1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                     width="40px" height="40px" viewBox="0 0 50 50" style="enable-background:new 0 0 50 50;" xml:space="preserve">
  <path fill="#000" d="M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z">
    <animateTransform attributeType="xml"
                      attributeName="transform"
                      type="rotate"
                      from="0 25 25"
                      to="360 25 25"
                      dur="0.6s"
                      repeatCount="indefinite"/>
    </path>
  </svg>
            </div>
        </div>
        </template>
        <div class="row">

            <div class="col-lg-6">
                <div class="form-group">
                    <label for="first_name">Ime <span class="required-mark">*</span></label>
                    <input type="text" class="form-control" id="first_name"
                           data-vv-name="Ime"
                           v-model="first_name" v-validate="'required'">

                    <p class="text-danger" v-if="errors.has('Ime')">{{ errors.first('Ime') }}</p>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="form-group">
                    <label for="last_name">Prezime <span class="required-mark">*</span></label>
                    <input type="text" class="form-control" id="last_name"
                           data-vv-name="Prezime"
                           v-model="last_name" v-validate="'required'">
                    <p class="text-danger" v-if="errors.has('Prezime')">{{ errors.first('Prezime') }}</p>
                </div>
            </div>
        </div>
        <div class="form-group">
            <label for="email">Email <span class="required-mark">*</span></label>
            <input type="email" class="form-control" id="email" name="email"
                   v-model="email"
                   data-vv-name="Email"
                   v-validate="'required|email'">

            <p class="text-danger" v-if="errors.has('Email')">{{ errors.first('Email') }}</p>
        </div>
        <div class="form-group">
            <label for="message">Poruka</label>
            <textarea name="message" id="message" class="form-control" rows="4"
                      v-model="message"
                      data-vv-name="Poruka"
                      v-validate="'required'"></textarea>
            <p class="text-danger" v-if="errors.has('Poruka')">{{ errors.first('Poruka') }}</p>
        </div>


        <div class="form-action-sec text-center">

            <button :disabled="isSend" id="submit" type="submit" class="btn btn-lg btn-coffee">Pošalji
            </button>
        </div>
    </form>
</template>

<script>
    // import {required, minLength} from 'vuelidate/lib/validators'
    // import SimpleVueValidation from 'simple-vue-validator';
    // const Validator = SimpleVueValidation.Validator;
    // Vue.use(SimpleVueValidation)
    export default {
        name: "contactFormComponent",

        data() {
            return {
                isLoading:false,
                isSend: false,
                first_name: '',
                last_name: '',
                email: '',
                message: '',
                csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
                recaptcha_token: '',
            }
        },

        methods: {
            validateBeforeSubmit() {
                this.isLoading = true;
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        this.$recaptcha('login').then((token) => {
                            // console.log("from $recaptcha");
                            this.recaptcha_token = token;
                            // console.log('token: ', token);
                            // console.log('this.recaptcha_token: ', this.recaptcha_token);
                            // console.log(token) // Will print the token
                            const vm = this;
                            const postData = {
                                first_name: vm.first_name,
                                last_name: vm.last_name,
                                email: vm.email,
                                message: vm.message,
                                'g-recaptcha-response': vm.recaptcha_token,
                                _token: vm.csrf
                            };
                            axios.post(APP_URL + '/kontakt', postData)
                                .then(function (response) {
                                    vm.isSend = true;
                                    vm.isLoading = false;
                                }).catch(function (error) {
                                console.log(error);
                                vm.isLoading = false;
                            });

                        });


                    }
                });


            }
        },
        mounted() {

        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/contactFormComponent.vue